/**
 * Checks if a value and all nested values are empty.
 */
export function isDeepEmpty(value) {
    if (typeof value === 'string') {
        return value.trim().length === 0;
    }
    if (Array.isArray(value)) {
        return value.length === 0 || value.every(isDeepEmpty);
    }
    if (value instanceof Map || value instanceof Set) {
        return value.size === 0 || Array.from(value.values()).every(isDeepEmpty);
    }
    if (value === null) {
        return true;
    }
    if (typeof value === 'object') {
        return Object.keys(value).length === 0 || Object.values(value).every(isDeepEmpty);
    }
    return value === undefined;
}
